import * as v from 'valibot';

export const adsFormSchema = v.object({
  status: v.string(),
});
